import { render, staticRenderFns } from "./FAQIndex.vue?vue&type=template&id=6d51f19b&scoped=true"
import script from "./FAQIndex.vue?vue&type=script&lang=js"
export * from "./FAQIndex.vue?vue&type=script&lang=js"
import style0 from "./FAQIndex.vue?vue&type=style&index=0&id=6d51f19b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d51f19b",
  null
  
)

export default component.exports